var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconHealth128(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_18327)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.7834 25.5027C97.3175 25.5027 107.478 35.4175 107.478 47.6481C107.478 54.2096 104.554 60.1046 99.9076 64.1597L64.8963 102.098L30.2657 64.4361C25.4323 60.3749 22.3721 54.3603 22.3721 47.6481C22.3721 35.4175 32.533 25.5027 45.0671 25.5027C53.6119 25.5027 61.0538 30.1106 64.9253 36.9188C68.7967 30.1106 76.2386 25.5027 84.7834 25.5027Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8613 64.8645H54.2459L61.9383 51.0347L69.6306 78.6942L77.3229 64.8645H113.861",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.287 72.3111C108.399 72.3111 111.733 68.977 111.733 64.8643C111.733 60.7515 108.399 57.4175 104.287 57.4175C100.174 57.4175 96.8398 60.7515 96.8398 64.8643C96.8398 68.977 100.174 72.3111 104.287 72.3111Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_18327"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white",
    transform: "translate(0 0.502686)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconHealth128);
export default __webpack_public_path__ + "static/media/pictogramBeaconHealth128.fc22f8ce039aa204a81cafd6349411ac.svg";
export { ForwardRef as ReactComponent };